"use client";

import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Ready() {
  const {
    ref: indexRef,
    isVisible: indexVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: line1Ref,
    isVisible: line1Visible
  } = useRevealOnScroll<HTMLSpanElement>({
    threshold: 0.15
  });
  const {
    ref: line2Ref,
    isVisible: line2Visible
  } = useRevealOnScroll<HTMLSpanElement>({
    threshold: 0.15
  });
  const {
    ref: ctaRef,
    isVisible: ctaVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return <section data-section-id="1603" id="ready-to-begin" className="dark bg-[#2F3631] text-[#E7D8C7] py-40 md:py-52 relative overflow-hidden">
      <div className="mx-auto max-w-5xl px-6 md:px-12">
        {}
        <div ref={indexRef} className="font-mono text-[0.75rem] uppercase tracking-[0.18em] text-[#8FA27C] transition-all duration-[600ms] ease-out" style={{
        transform: indexVisible ? "translateY(0)" : "translateY(16px)",
        opacity: indexVisible ? 1 : 0
      }}>
          § 06 — INTAKE
        </div>

        {}
        <div className="h-16" />

        {}
        <div className="relative">
          {}
          <div aria-hidden="true" className="pointer-events-none absolute -bottom-12 right-0 select-none font-default font-thin leading-none text-[#E7D8C7]/5" style={{
          fontSize: "28vw"
        }}>
            06
          </div>

          {}
          <h2 className="relative font-default font-extralight text-[#E7D8C7]" style={{
          fontSize: "clamp(2.375rem, 5.6vw, 5.75rem)",
          letterSpacing: "-0.03em",
          lineHeight: 1.04
        }}>
            <span ref={line1Ref} className="block transition-all duration-[700ms] ease-out" style={{
            transform: line1Visible ? "translateY(0)" : "translateY(16px)",
            opacity: line1Visible ? 1 : 0
          }}>
              When you are ready to proceed,
            </span>
            <span ref={line2Ref} className="block transition-all duration-[700ms] ease-out" style={{
            transform: line2Visible ? "translateY(0)" : "translateY(16px)",
            opacity: line2Visible ? 1 : 0,
            transitionDelay: "140ms"
          }}>
              <em className="not-italic italic transition-colors duration-[600ms] ease-out" style={{
              color: line2Visible ? "#C89F7B" : "#E7D8C7",
              transitionDelay: "540ms",
              fontStyle: "italic"
            }}>
                start the intake process
              </em>
              .
            </span>
          </h2>
        </div>

        {}
        <div className="h-20" />

        {}
        <div ref={ctaRef} className="flex flex-col md:flex-row md:items-center gap-12 transition-all duration-[700ms] ease-out" style={{
        transform: ctaVisible ? "translateY(0)" : "translateY(16px)",
        opacity: ctaVisible ? 1 : 0,
        transitionDelay: "220ms"
      }}>
          {}
          <Link to="/IntakePathPage">
            <Button variant="outline" className="bg-[#8FA27C] border-none text-white hover:bg-[#5E6A52] px-9 py-5 h-auto font-default text-base tracking-[0.04em] transition-colors duration-300 ease-out">
              Begin Intake
            </Button>
          </Link>

          {}
          <Link to="/ContactPage" className="group inline-flex items-center font-default text-[#E7D8C7] text-base tracking-[0.01em] transition-colors duration-220">
            <span className="relative pb-1.5 border-b border-[#5E6A52] group-hover:border-[#C89F7B] transition-all duration-220 ease-out">
              Or contact our team
            </span>
          </Link>

          {}
          <div className="font-mono text-[0.75rem] uppercase tracking-[0.08em] text-[#8FA27C] md:ml-auto">
            ARIZONA · NEUTRAL · PROFESSIONAL
          </div>
        </div>
      </div>

      {}
      <div className="mt-32 md:mt-44 relative">
        <div className="h-px w-full bg-[#5E6A52]" />
        <div className="absolute right-0 top-1/2 -translate-y-1/2 size-1.5" style={{
        backgroundColor: "#C89F7B"
      }} />
      </div>
    </section>;
}